import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Route,Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class ApicallService {
  constructor(private httpClient: HttpClient,private route:Router) {}

  getGetseo(tbody: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('dbid', '0');
    return this.httpClient
      .post(environment.cmsapi_url + `Getseo`, tbody, { headers: headers })
      .pipe(
        map((data: any) => {
          if(data && Object.keys(data.data).length > 0){
            return data;
          }else{
            this.route.navigateByUrl('page-not-found');
          }
          
        }),
        catchError((error) => {
          console.log(error);
          return throwError('Something went wrong!');
        })
      );
  }
  getGetblog(tbody: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('dbid', '0');
    return this.httpClient
      .post(environment.cmsapi_url + `Getblogdata`, tbody, { headers: headers })
      .pipe(
        map((data: any) => {
          if(data && Object.keys(data?.data)?.length > 0){
            return data;
          }else{
            this.route.navigateByUrl('page-not-found');
          }
        }),
        catchError((error) => {
          return throwError('Something went wrong!');
        })
      );
  }
  
  checkMicrosite(data:any):Observable<any>{
    return this.httpClient.post(environment.cmsapi_url +'checkIsmicrosite',data);
    
  }
}
